import React, { useEffect, useState } from "react";
import MedicalService from "../../Services/MedicalService";
import dayjs from "dayjs";
import { HSdecrypt } from "../../utils/encryptPassword";

function Medication(props) {
  const [medicationData, setMedication] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    patientMedication();
  }, [props.selectedPatient]);

  const patientMedication = () => {
    let payload = {
      patientCode: props.selectedPatient,
      status: 1,
    };
    MedicalService.HSPatientMedication(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setMedication(JSON.parse(decryptedData));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div
      className="bg-white rounded-xl border border-gray-200 shadow-sm w-full"
      id="unquie-scroll"
    >
      <div className="flex justify-between items-center p-3">
        <h3 className="text-sm font-bold text-gray-700">Medication</h3>
        <div className="flex items-center gap-2 text-blue-500 font-sans font-medium underline text-xs cursor-pointer">
          {/* <HiPlusCircle className="text-primaryColor w-7 h-7"/> */}
        </div>
      </div>
      <hr />
      <div className="h-60 p-3 overflow-y-scroll flex flex-col gap-3 scrollWidth">
        {medicationData.length > 0 ? (
          medicationData.map((user, i) => (
            <div
              className="relative"
              onMouseEnter={() => setHoveredIndex(i)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="overflow-y-scroll pr-2 scrollWidth flex flex-col gap-2">
                <div className="bg-[#FFF8FB] border border-[#FFA2CB] border-l-4 rounded-lg p-3 text-xs text-gray-700 flex flex-col gap-2">
                  <p>
                    <strong>Drug Name:</strong> {user.drugName}
                  </p>
                  <p>
                    Onset Date : {dayjs(user.givenDate).format("YYYY-MM-DD")}
                  </p>
                </div>
              </div>
              {hoveredIndex === i && (
                <div
                  className="fixed bg-[#585858] text-white text-xs rounded-lg shadow-lg p-3 z-50"
                  style={{ top: "200px", left: "400px" }}
                >
                  {" "}
                  {user.drugName && (
                    <p>
                      <strong>Drug Name:</strong> {user.drugName}
                    </p>
                  )}
                  {user.composition && (
                    <p>
                      <strong>Composition:</strong> {user.composition}
                    </p>
                  )}
                  {user.dosage && (
                    <p>
                      <strong>Dosage:</strong> {user.dosage}
                    </p>
                  )}
                  {user.frequency && (
                    <p>
                      <strong>Frequency:</strong> {user.frequency}
                    </p>
                  )}
                  {user.duration && (
                    <p>
                      <strong>Duration:</strong> {user.duration}
                    </p>
                  )}
                  {user.indication && (
                    <p>
                      <strong>Indication:</strong> {user.indication}
                    </p>
                  )}
                  {user.sideEffects && (
                    <p>
                      <strong>Side Effects:</strong> {user.sideEffects}
                    </p>
                  )}
                  {user.compliance && (
                    <p>
                      <strong>Compliance:</strong> {user.compliance}
                    </p>
                  )}
                  {user.adverseEffects && (
                    <p>
                      <strong>Adverse Effects:</strong> {user.adverseEffects}
                    </p>
                  )}
                  {user.adviceRelatedMedicine && (
                    <p>
                      <strong> Advice related to medicine:</strong>{" "}
                      {user.adviceRelatedMedicine}
                    </p>
                  )}
                  <p>
                    <strong>Onset date:</strong>{" "}
                    {dayjs(user.givenDate).format("YYYY-MM-DD")}
                  </p>
                </div>
              )}
            </div>
          ))
        ) : (
          <div></div>
        )}
      </div>
    </div>
    // <div className=" w-full max-w-[370px] h-[300px] sm:h-[340px] md:h-[370px] md:m-5 border rounded-lg">
    //   <div className="header h-[13%] bg-secondaryColor flex items-center justify-center rounded p-2">
    //     <h1 className="font-bold text-normal text-white mt-3">Medication</h1>
    //   </div>
    //   <div className="body h-[75%] scrollwidth overflow-y-auto bg-white border-t-2">

    //     {
    //       medicationData.length > 0 ?
    //         (
    //           medicationData.map((user, i) => (
    //             <div className="items-center m-3 p-2 border rounded-md text-sm">
    //               <p className="font-semibold">Drug Name: <span className="font-medium text-gray-500">{user.drugName}</span></p>
    //               <p className="font-semibold">Composition: <span className="font-medium text-gray-500">{user.composition ? user.composition : "N/A"}</span></p>
    //               <p className="font-semibold">Dosage: <span className="font-medium text-gray-500">{user.dosage}</span></p>
    //               <p className="font-semibold">Frequency: <span className="font-medium text-gray-500">{user.frequency}</span></p>
    //               <p className="font-semibold">Duration: <span className="font-medium text-gray-500">{user.duration} {user.durationType}</span></p>
    //               <p className="font-semibold">Indication: <span className="font-medium text-gray-500">{user.indication}</span></p>
    //               <p className="font-semibold">Side Effects: <span className="font-medium text-gray-500">{user.sideEffects}</span></p>
    //               <p className="font-semibold">Compliance: <span className="font-medium text-gray-500">{user.compliance}</span></p>
    //               <p className="font-semibold">Adverse Effects: <span className="font-medium text-gray-500">{user.adverseEffects}</span></p>
    //               <p className="font-semibold">Advice related to medicine: <span className="font-medium text-gray-500">{user.adviceRelatedMedicine}</span></p>
    //               <div className="ml-auto font-medium mt-2 flex justify-start">
    //                 <h5 className="text-gray-500 font-semibold text-sm">
    //                   Onset date: <span> {dayjs(user.givenDate).format('YYYY-MM-DD')}</span>
    //                 </h5>
    //               </div>
    //             </div>
    //           ))
    //         )
    //         :
    //         null
    //     }
    //   </div>
    //   <div className="footer h-[44px] bg-secondaryColor rounded"></div>
    // </div>
  );
}

export default Medication;
